import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { UploadService } from '../services/upload-service';

/**
 * Protège `/content-creation/upload` : la page n'a de sens que si une session
 * d'upload a été ouverte et que l'API a renvoyé toutes les URLs S3 attendues
 * (GPS seul pour un gps-only, GPS + vidéo sinon).
 * Sinon on renvoie l'utilisateur sur le formulaire de création.
 */
export const uploadGuard: CanActivateFn = (): boolean | UrlTree =>
  inject(UploadService).uploadSessionReady() || inject(Router).createUrlTree(['/content-creation']);
